import React from 'react'
import './index.scss'

interface TagInterface {
  className?: string
  backgroundColor?: string
  borderColor?: string
  fontColor?: string
  children: React.ReactNode
}
function Tag(props: TagInterface) {
  const { className, backgroundColor, borderColor, fontColor, children } = props || {};

  return (
    <div
      className={`c-tag ${className ? className : ''}`}
      style={{
        backgroundColor,
        color: fontColor,
        borderColor: borderColor || backgroundColor
      }}
    >
      {children}
    </div>
  )
}

Tag.defaultProps = {
  backgroundColor: '#F08F48',
  fontColor: '#FFFFFF'
}

export default Tag
